<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="chapter">
<div epub:type="frontmatter">
<section epub:type="division">
<div class="dis_img" id="figvi"><img alt="" src="Images/1-1.jpg"/>
<p class="caption11">Strollers traverse Manhattan’s Grand Army Plaza, the Hotel New Netherland (opened in 1892–93) prominent in the background. That hotel was replaced in 1927 by the Sherry-Netherland.</p>
</div>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454925767_epub_fm1_r1.vue?3b6a0982